import { jsxs as i, jsx as n } from "react/jsx-runtime";
import { useTranslation as m } from "../../hooks/useTranslation/index.js";
import { LoadMoreButtonContainer as l, LoadMoreButtonText as d, LoadMoreButtonArrow as u } from "./style.js";
import { ChevronDown as c } from "@pelando/fontawesome/icons";
function x({
  onLoadMore: e,
  loading: o,
  className: a
}) {
  const { t: r } = m("common"), t = r(o ? "load-more-button-loading" : "load-more-button");
  return /* @__PURE__ */ i(
    l,
    {
      onClick: e,
      disabled: o,
      "aria-label": t,
      className: a,
      children: [
        /* @__PURE__ */ n(d, { children: t }),
        !o && /* @__PURE__ */ n(u, { role: "img", icon: c })
      ]
    }
  );
}
export {
  x as LoadMoreButton
};
